// src/hooks/nationalities/useForceDeleteNationality.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteNationality as forceDeleteNationalityAPI } from "../../api/apiNationalities";
import parseError from "../../utils/parseError";

const useForceDeleteNationality = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDelete, isPending: isForceDelete } = useMutation({
        mutationFn: forceDeleteNationalityAPI,
        onSuccess: (res) => {
            const message = res?.message || "Nationality permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["nationalities"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete nationality");
        },
    });

    return { forceDeleteNationality: forceDelete, isForceDelete };
};

export default useForceDeleteNationality;